import { useEffect } from "react";

const rawSiteUrl: string =
  typeof import.meta.env.VITE_SITE_URL === "string"
    ? import.meta.env.VITE_SITE_URL
    : "";

const siteOrigin = rawSiteUrl.replace(/\/+$/, "");

const LOGO_URL =
  "https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/f74a46007c2be116dc4d23be74f0eb02.png";

const restaurantSchema = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: "Bertie's Restaurant & Cocktails",
  url: `${siteOrigin}/`,
  logo: LOGO_URL,
  image: LOGO_URL,
  servesCuisine: "Caribbean",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "2088 Badlands Drive",
    addressLocality: "Brandon",
    addressRegion: "FL",
    postalCode: "33511",
    addressCountry: "US",
  },
  telephone: "(786) 424-7388",
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Wednesday", "Thursday", "Friday"],
      opens: "15:00",
      closes: "23:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "11:00",
      closes: "23:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Sunday",
      opens: "11:00",
      closes: "20:00",
    },
  ],
};

export default function RestaurantJsonLd() {
  useEffect(() => {
    const scriptId = "restaurant-jsonld";
    if (document.getElementById(scriptId)) {
      return;
    }
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    script.textContent = JSON.stringify(restaurantSchema);
    document.head.appendChild(script);
  }, []);

  return null;
}